module.exports = __webpack_public_path__ + "static/media/GA_Feedback_2018.10.6 (2).5306f226.jpg";